export default {
	namespaced: true,

	state: {},

	mutations: {},

	actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/main.js